export enum ListsDashboardSourceEnum {
  pipeline = 'pipeline',
  deals = 'deals',
  availabilities = 'availabilities',
  comparables = 'comparables',
}
